import { Controller, useFormContext } from 'react-hook-form';
import FormControlledInput from '../../../../components/inputs/FormInputs/FormControlledInput';
import { DocumentDropOffFields } from '../../../../Interfaces/Accounting/ACForms.interfaces';
import FormErrorMessage from '../../../../components/messages/FormErrorMessage';
import { transformBToMB } from '@/src/utils/fileUtil';
import { FILE_20_MB_LIMIT } from '@/src/utils/fileConsts';
import FormControlledInputArea from '@/src/app/components/inputs/FormInputs/FormControlledInputArea';
import MultipleFileInput from '../../../../components/inputs/StyledInputs/MultipleFileInput';

const DropOffForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<DocumentDropOffFields>();

  return (
    <div>
      <div className="grid mx-3 justify-content-center">
        <div className="col-12">
          <label htmlFor="phase" className="text-standard block mb-2">
            Documents
          </label>
          <Controller
            name="documents"
            aria-label="file-input"
            control={control}
            rules={{
              required: {
                value: true,
                message: 'Documents is a required field',
              },
            }}
            render={({ field: { onChange, value } }) => (
              <div>
                <MultipleFileInput
                  value={value}
                  onChange={onChange}
                  totalLimit={FILE_20_MB_LIMIT}
                  totalLimitLabel={`${transformBToMB(FILE_20_MB_LIMIT)} MB`}
                  emptyMessage={'Upload files.'}
                  contentClassName={errors['documents'] && 'border-red-500'}
                />
                {errors['documents'] && (
                  <FormErrorMessage
                    errorMessage={errors['documents'].message as string}
                  />
                )}
              </div>
            )}
          />
        </div>
        <div className="col-12">
          <label htmlFor="attentionTo" className="text-standard block mb-2">
            Attention To
          </label>
          <FormControlledInput
            defaultValue=""
            formID="attentionTo"
            autocomplete="off"
          />
        </div>
        <div className="col-12">
          <label htmlFor="notes" className="text-standard block mb-2">
            Notes
          </label>
          <FormControlledInputArea
            defaultValue=""
            formID="notes"
            rows={5}
            cols={60}
            rules={{
              required: {
                value: true,
                message: 'Notes is a required field',
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DropOffForm;
